export default {"src":"/_next/static/media/arrow-left.617866dc.svg","height":24,"width":24};